import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { ArrowRight, Star } from 'lucide-react';
export function TransformationSection() {
  const transformations = ['Ofrecer manicura desde tu casa con seguridad', 'Conseguir tus primeras clientas y empezar a generar ingresos rápidamente', 'Mejorar tus habilidades con técnicas claras y fáciles de seguir', 'Organizar tu espacio de trabajo y tus horarios de manera eficiente', 'Sentirte segura y motivada para crecer como profesional de la manicura'];
  return <section className="py-24 bg-dark text-white relative overflow-hidden" data-id="element-231">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-rose-900/20 blur-3xl rounded-full transform translate-x-1/2" data-id="element-232"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-full bg-gold-900/20 blur-3xl rounded-full transform -translate-x-1/2" data-id="element-233"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-234">
        <div className="text-center mb-16" data-id="element-235">
          <motion.span className="text-gold-400 font-bold tracking-wider uppercase text-sm mb-4 block" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-236">
            La Transformación
          </motion.span>
          <SectionHeading title="Imaginá poder:" light={true} data-id="element-237" />
        </div>

        <div className="space-y-6 mb-16" data-id="element-238">
          {transformations.map((item, index) => <motion.div key={index} className="bg-white/5 border border-white/10 backdrop-blur-sm p-6 rounded-2xl flex items-center gap-6 hover:bg-white/10 transition-colors" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-239">
              <div className="bg-gold-500/20 p-3 rounded-full shrink-0" data-id="element-240">
                <Star className="w-6 h-6 text-gold-400 fill-gold-400" data-id="element-241" />
              </div>
              <p className="text-lg md:text-xl font-medium text-rose-50" data-id="element-242">
                {item}
              </p>
            </motion.div>)}
        </div>

        <motion.div className="text-center bg-gradient-to-r from-rose-600 to-rose-500 p-8 rounded-3xl shadow-2xl shadow-rose-500/20" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-243">
          <p className="text-xl md:text-2xl font-playfair font-bold mb-0" data-id="element-244">
            Con este ebook, vas a tener todo lo que necesitás para empezar a
            ganar dinero desde casa en pocas semanas.
          </p>
        </motion.div>
      </div>
    </section>;
}